export const POST_VACCINATION_REACTIONS_PETS_CSV = `code,ru,en
localReactions,Местные реакции,Local reactions
redness,Покраснение,Redness
slightSwelling,Небольшой отёк (припухлость),Slight swelling
mildSoreness,Лёгкая болезненность при прикосновении,Mild soreness
induration,Уплотнение (узелок) в месте инъекции,Induration (nodule) at injection site
localHairLoss,Локальное выпадение шерсти,Local hair loss
itchingOrLicking,Зуд или облизывание (поцарапывание) места укола,Itching or licking (scratching) at injection site
generalReactions,Общие реакции,General reactions
slightTemperatureElevation,Небольшое повышение температуры,Slight temperature elevation
weaknessLethargyDrowsiness,Слабость / вялость / сонливость,Weakness / lethargy / drowsiness
decreasedActivity,Снижение активности,Decreased activity
decreasedAppetite,Снижение аппетита,Decreased appetite
mildNausea,Лёгкая тошнота (рвота),Mild nausea (vomiting)
shortTermDiarrhea,Кратковременная диарея,Short-term diarrhea
shortTermTremor,Кратковременный тремор (дрожь),Short-term tremor (shaking)
allergicReactions,Аллергические реакции,Allergic reactions
urticaria,Крапивница (волдыри на коже),Urticaria (skin blisters)
severeItching,Сильный зуд,Severe itching
angioedema,Отёк морды / ушей / век (ангионевротический отёк),Angioedema (swelling of muzzle / ears / eyelids)
difficultyBreathing,Затруднённое дыхание,Difficulty breathing
anaphylaxis,Анафилаксия,Anaphylaxis
respiratoryReactions,Респираторные реакции,Respiratory reactions
rapidBreathing,Учащённое дыхание,Rapid breathing
wheezing,Свистящее дыхание (хрипы),Wheezing
shortnessOfBreath,Одышка,Shortness of breath
cardiovascularReactions,Сердечно-сосудистые реакции,Cardiovascular reactions
tachycardia,Тахикардия,Tachycardia
paleMucousMembranes,Бледные слизистые,Pale mucous membranes
collapse,Коллапс (обморок),Collapse (fainting)`;
